import React from 'react'
import { useLocation } from 'react-router-dom'
import { PRODUCTS } from '../lib/payments'

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://opraiz.com'

const absoluteUrl = (path) => (/^https?:\/\//.test(path) ? path : `${SITE_URL}${path}`)

const META = {
  '/': {
    title: 'OPRAIZ — AI Workforce, Assistant, Video & Cybersecurity',
    description:
      'OPRAIZ builds its own AI models and shapes them into products: IDEOSCREEN creative production, SCENEVIZ moving worlds, AIMG model garage — with ORBO DIYA, BAANZON CHAT and adaptive security on the way.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/pricing': {
    title: 'Pricing — OPRAIZ',
    description:
      'Reference pricing for OPRAIZ R&D platforms, direct-procurement access to released products, and waitlists for the next wave.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/checkout': {
    title: 'Checkout — OPRAIZ',
    description: 'Complete your subscription to OPRAIZ — your AI & SaaS platform.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/payment-success': {
    title: 'Payment Successful — OPRAIZ',
    description: 'Your subscription is now active.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/payment-failed': {
    title: 'Payment Failed — OPRAIZ',
    description: 'Something went wrong. Please try again.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/account': {
    title: 'My Account — OPRAIZ',
    description: 'Manage your subscription, view payments, and update your billing details.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/products': {
    title: 'Products — OPRAIZ',
    description:
      'IDEOSCREEN, SCENEVIZ and AIMG released today; ORBO DIYA, BAANZON CHAT and OCTOPUS SHIELD releasing soon; healthcare and government platforms in active R&D — one shared AI core.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/company': {
    title: 'Company — OPRAIZ',
    description: 'About Opraiz Technology Pvt Ltd — an AI-native technology company founded in 2026, building AI tools and SaaS for every sector.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/marketplace': {
    title: 'Marketplace — OPRAIZ',
    description: 'SaaS products, AI tools and partner apps for your OPRAIZ workspace — built by approved publishers.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/marketplace/publish': {
    title: 'Publish on OPRAIZ — Become a Publisher',
    description: 'List your product in the OPRAIZ Marketplace and reach hospitals, clinics and government institutions.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/marketplace/publisher': {
    title: 'Publisher Dashboard — OPRAIZ',
    description: 'Manage your marketplace products, subscribers, analytics and payouts.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/privacy-policy': {
    title: 'Privacy Policy — OPRAIZ',
    description: 'How we collect, use, and protect your data.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/terms-of-service': {
    title: 'Terms of Service — OPRAIZ',
    description: 'Terms governing use of OPRAIZ platforms and services.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/blog': {
    title: 'Blog — OPRAIZ',
    description: 'Guides, product stories and industry perspectives from the OPRAIZ team.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/integrations': {
    title: 'Integrations — OPRAIZ',
    description: 'Connect OPRAIZ platforms with the tools your organisation already uses.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/changelog': {
    title: 'Changelog — OPRAIZ',
    description: 'Product updates, improvements and fixes across OPRAIZ platforms.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/demo': {
    title: 'Live Demos — OPRAIZ',
    description: 'Explore interactive demos of the OPRAIZ stack — guided walkthroughs of released and in-development products.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/demo/schedule': {
    title: 'Book a Demo — OPRAIZ',
    description: 'Schedule a personal walkthrough of OPRAIZ with our team.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/build': {
    title: 'R&D Services — OPRAIZ',
    description: 'Custom AI and software R&D built end-to-end, from idea to deployment.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/whitelabel': {
    title: 'White-Label — OPRAIZ',
    description: 'Launch OPRAIZ platforms under your own brand.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/deploy': {
    title: 'Enterprise Deploy — OPRAIZ',
    description: 'Private, secure deployment of OPRAIZ for enterprises and governments.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/support': {
    title: 'Support — OPRAIZ',
    description: 'Get help with your OPRAIZ platform — we are available 7 days a week.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/signup': {
    title: 'Create Account — OPRAIZ',
    description: 'Create your OPRAIZ account to get started.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/login': {
    title: 'Sign In — OPRAIZ',
    description: 'Sign in to your OPRAIZ account.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/login/admin': {
    title: 'Admin Sign In — OPRAIZ',
    description: 'Sign in to the OPRAIZ management console.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/forgot-password': {
    title: 'Reset Password — OPRAIZ',
    description: 'Reset the password for your OPRAIZ account.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/reset-password': {
    title: 'Reset Password — OPRAIZ',
    description: 'Reset the password for your OPRAIZ account.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/admin': {
    title: 'Admin Console — OPRAIZ',
    description: 'OPRAIZ management console — users, vendors, marketplace approvals and payouts.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/support/admin': {
    title: 'Support Admin — OPRAIZ',
    description: 'Manage support tickets across OPRAIZ platforms.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/dashboard': {
    title: 'Dashboard — OPRAIZ',
    description: 'Your OPRAIZ workspace dashboard.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/notifications': {
    title: 'Notifications — OPRAIZ',
    description: 'Your OPRAIZ notifications.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/wishlist': {
    title: 'Wishlist — OPRAIZ',
    description: 'Your saved marketplace products.',
    image: '/og/opraiz-og-1200x630.png',
  },
  '/cart': {
    title: 'Cart — OPRAIZ',
    description: 'Your marketplace cart.',
    image: '/og/opraiz-og-1200x630.png',
  },
}

// Known parameterised route patterns that render real pages (never 404).
// Used to keep the document title accurate on dynamic/authenticated routes
// instead of wrongly labelling them "Page Not Found".
const DYNAMIC_TITLES = [
  { test: /^\/support\/tickets(\/.*)?$/, title: 'Support Tickets — OPRAIZ' },
  { test: /^\/blog\/.+$/, title: 'Blog — OPRAIZ' },
  { test: /^\/marketplace\/(?!publish|publisher)[^/]+$/, title: 'Marketplace — OPRAIZ' },
  { test: /^\/demo\/[^/]+(\/[^/]+)?$/, title: 'Live Demos — OPRAIZ' },
]

function getProductMeta(pathname) {
  const match = pathname.match(/^\/products\/(.+)$/)
  if (!match) return null
  const slug = match[1]
  const product = PRODUCTS.find((p) => p.id === slug)
  if (!product) return null
  const hasPlans = product.plans.some((p) => p.monthly?.price)
  return {
    title: hasPlans
      ? `${product.name} Pricing — OPRAIZ`
      : `${product.name} — ${product.category} — OPRAIZ`,
    description: `${product.tagline}. ${product.description}`,
    image: '/og/opraiz-og-1200x630.png',
  }
}

function getMarketplaceMeta(pathname) {
  const match = pathname.match(/^\/marketplace\/([^/]+)$/)
  if (!match) return null
  const slug = match[1] === 'publish' || match[1] === 'publisher' ? null : match[1]
  return {
    title: `${slug} — OPRAIZ Marketplace`,
    description: `Marketplace product ${slug} on OPRAIZ.`,
    image: '/og/opraiz-og-1200x630.png',
  }
}

function getDynamicMeta(pathname) {
  const entry = DYNAMIC_TITLES.find((d) => d.test.test(pathname))
  return entry
    ? { title: entry.title, description: `${entry.title.replace(' — OPRAIZ', '')} on OPRAIZ.`, image: '/og/opraiz-og-1200x630.png' }
    : null
}

// Normalise trailing slashes so hosts that append "/" (e.g. S3/CloudFront
// error-document redirects) still resolve the correct per-route meta instead of
// falling through to "Page Not Found".
const normalizePath = (pathname) => {
  let p = pathname || '/'
  if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1)
  return p
}

const SEORouter = () => {
  const location = useLocation()
  const pathname = normalizePath(location.pathname)
  const productMeta = getProductMeta(pathname)
  const marketplaceMeta = getMarketplaceMeta(pathname)
  const meta = productMeta || marketplaceMeta || META[pathname] ||
    getDynamicMeta(pathname) || {
    title: 'Page Not Found — OPRAIZ',
    description: 'The page you are looking for does not exist.',
    image: '/og/opraiz-og-1200x630.png',
  }

  const product = productMeta
    ? PRODUCTS.find((p) => p.id === pathname.split('/').pop())
    : null

  React.useEffect(() => {
    document.title = meta.title

    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`)
      if (el) el.setAttribute('content', content)
      else {
        el = document.createElement('meta')
        el.name = name
        el.content = content
        document.head.appendChild(el)
      }
    }

    const setOg = (property, content) => {
      let el = document.querySelector(`meta[property="${property}"]`)
      if (el) el.setAttribute('content', content)
      else {
        el = document.createElement('meta')
        el.setAttribute('property', property)
        el.content = content
        document.head.appendChild(el)
      }
    }

    // Structured data: replace or remove per-route JSON-LD blocks.
    const setJsonLd = (id, data) => {
      document.querySelectorAll('script[id^="ld-"]').forEach((el) => el.remove())
      if (!data) return
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.id = `ld-${id}`
      script.textContent = JSON.stringify(data)
      document.head.appendChild(script)
    }

    if (product && product.plans.some((pl) => pl.monthly?.price)) {
      const offers = product.plans
        .filter((p) => p.monthly?.price)
        .map((p) => ({
          '@type': 'Offer',
          name: p.name,
          price: String(p.monthly.price),
          priceCurrency: p.monthly.currency || 'INR',
          availability: 'https://schema.org/InStock',
          url: `${SITE_URL}/checkout?product=${product.id}&plan=${p.id}&period=monthly`,
        }))
      setJsonLd('product', {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: `${product.name} — OPRAIZ`,
        description: product.description,
        image: absoluteUrl(product.preview || '/og/opraiz-og-1200x630.png'),
        brand: { '@type': 'Brand', name: 'OPRAIZ' },
        offers: { '@type': 'AggregateOffer', lowPrice: String(Math.min(...offers.map((o) => Number(o.price)))), highPrice: String(Math.max(...offers.map((o) => Number(o.price)))), priceCurrency: 'INR', offerCount: offers.length, offers },
      })
    } else if (pathname === '/pricing') {
      setJsonLd('faq', {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Does OPRAIZ offer a free trial?',
            acceptedAnswer: { '@type': 'Answer', text: 'We offer a guided demo instead of a free trial so we can tailor the platform to your workflow.' },
          },
          {
            '@type': 'Question',
            name: 'Can I upgrade my plan later?',
            acceptedAnswer: { '@type': 'Answer', text: 'Yes, you can upgrade anytime. Moving to a larger plan applies prorated billing for the remainder of the period.' },
          },
        ],
      })
    } else {
      setJsonLd('route', null)
    }

    setMeta('description', meta.description)
    setOg('og:title', meta.title)
    setOg('og:description', meta.description)
    setOg('og:image', absoluteUrl(meta.image))
    setOg('og:url', `${SITE_URL}${pathname}`)
    setOg('og:locale', 'en_IN')
    setMeta('twitter:title', meta.title)
    setMeta('twitter:description', meta.description)
    setMeta('twitter:image', absoluteUrl(meta.image))
    setMeta('twitter:card', 'summary_large_image')

    const setLink = (rel, href, hreflang) => {
      const selector = hreflang
        ? `link[rel="${rel}"][hreflang="${hreflang}"]`
        : `link[rel="${rel}"]`
      let el = document.querySelector(selector)
      if (!el) {
        el = document.createElement('link')
        el.rel = rel
        if (hreflang) el.hreflang = hreflang
        document.head.appendChild(el)
      }
      el.href = href
    }

    const canonical = `${SITE_URL}${pathname}`
    setLink('canonical', canonical)
    setLink('alternate', `${canonical}?lang=hi`, 'hi-IN')
    setLink('alternate', `${canonical}?lang=en`, 'en-IN')

    // robots index/follow now that pages resolve.
    setMeta('robots', 'index, follow')
  }, [pathname, meta.title, meta.description, meta.image, product])

  return null
}

export default SEORouter
